import { useEffect, useRef } from 'react'
import { X, Maximize2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import TradeDetailContent from './TradeDetailContent'
import SetupTradeDetailContent from './SetupTradeDetailContent'

export default function TradeSlideOver({ tradeId, nicknameMap, onClose, projectId, setupGroup }) {
  const navigate = useNavigate()
  const panelRef = useRef(null)

  // Close on Escape
  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [onClose])

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = '' }
  }, [])

  function handleExpand() {
    onClose()
    navigate(setupGroup
      ? `/positions/history/${setupGroup.trades[0].id}?setup=${encodeURIComponent(setupGroup.id)}`
      : `/positions/history/${tradeId}`)
  }

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div
        className="absolute inset-0 transition-opacity duration-300"
        style={{ background: 'rgba(0, 0, 0, 0.4)' }}
        onClick={onClose}
      />

      {/* Panel */}
      <div
        ref={panelRef}
        className="relative w-full sm:w-[50vw] sm:min-w-[420px] sm:max-w-[700px] h-full flex flex-col animate-slide-in-right"
        style={{
          background: 'rgb(var(--color-canvas))',
          borderLeft: '1px solid rgb(var(--color-border))',
        }}
      >
        {/* Panel header buttons */}
        <div className="absolute top-3 right-3 z-10 flex items-center gap-1">
          <button
            onClick={handleExpand}
            className="p-1.5 rounded-lg transition-colors hover:bg-canvas2"
            title="Open full page"
          >
            <Maximize2 size={14} className="text-inkMuted" />
          </button>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg transition-colors hover:bg-canvas2"
            title="Close"
          >
            <X size={14} className="text-inkMuted" />
          </button>
        </div>

        {setupGroup
          ? <SetupTradeDetailContent key={setupGroup.id} group={setupGroup} nicknameMap={nicknameMap} />
          : <TradeDetailContent key={tradeId} tradeId={tradeId} nicknameMap={nicknameMap} projectId={projectId} />}
      </div>

      {/* Slide-in animation */}
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slide-in-right {
          animation: slideInRight 300ms ease both;
        }
      `}</style>
    </div>
  )
}
